import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deliveryPartnerId: null,
  viewData: null,
};

const deliveryPartnerViewSlice = createSlice({
  name: "deliveryPartnerView",
  initialState,
  reducers: {
    setDeliveryPartnerData: (state, action) => {
      const { id, viewData } = action.payload;
      state.deliveryPartnerId = id ?? null;
      state.viewData = viewData ?? null;
    },
    clearDeliveryPartnerData: (state) => {
      state.deliveryPartnerId = null;
      state.viewData = null;
    },
  },
});

export const { setDeliveryPartnerData, clearDeliveryPartnerData } =
  deliveryPartnerViewSlice.actions;

export default deliveryPartnerViewSlice.reducer;
